// extracted by mini-css-extract-plugin
export default {"controlPanel":"items-page-module_controlPanel-fwL1K","controlButton":"items-page-module_controlButton-PlJjL"};